import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { GeofenceEvent } from '../../../API/types/Geofences';
import Tags from '../Tags';
import { ListItemWrapper } from '../../ui/ListItemWrapper/ListItemWrapper';
import { getFormattedDateAndTime, getTimeZone } from '../../../utils/dateUtils';
import { IconKeys } from '../Icon/IconKeys';
import { ThemeType } from '../../../theme/themeType';

type Props = {
  item?: GeofenceEvent,
  lightVersion?: boolean,
};

function GeofenceEventItem({ item, lightVersion }: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const navigate = useNavigate();
  const vehicleId = item?.vehicleId;

  return (
    <ListItemWrapper
      onClick={vehicleId ? () => navigate(`/vehicles/${vehicleId}`) : undefined}
      noclick={!vehicleId}
      title={vehicleId ? 'Open vehicle details' : undefined}
    >
      <Tags.Label
        label={item?.geofenceName || 'Geofence Name - N/A'}
      />
      <Tags.LabeledIcon
        flexible
        label={item?.createdAt ? `${getFormattedDateAndTime(item?.createdAt)} (${getTimeZone(item?.createdAt)})` : 'Time N/A'}
        icon={IconKeys.TIME}
      />
      <Tags.Status
        label={item?.direction.toUpperCase() || 'Status N/A'}
        backgroundColor={theme.colors.inactive}
      />
    </ListItemWrapper>
  );
}

export default GeofenceEventItem;
